require('./choreListTableRow.scss');
// @ vendor
const { connect } = require('react-redux');
const classNames = require('classnames');
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require('react-router-dom');

// @ commons
const { formatText } = require('core/i18n').i18n;
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OKCollapsingToggler } = require('commonsComponents/OKCollapsingToggler');
const { LabelDate } = require('commonsComponents/labelDate');
const { getLanguage, FormattedText } = require('core/i18n').i18n;

// @constants
const { LABEL_DATE_TODAY, LABEL_DATE_YESTERDAY } = require('constants/commonsComponents');
const {
    OPENYOUNG_CHORE_PENDING,
    OPENYOUNG_CHORE_DELETED,
    EURO_TEXT
} = require('constants/index');

// @ utilities
const { formatCurrency, getFormattedString } = require('utilities/currencyHelper');
const { getFirstNWords } = require('utilities/stringHelper');
const { hash } = require('utilities/hash');

class ChoreListTableRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            rowId: ''
        }
        this.onRowClick = this.onRowClick.bind(this);
        this.buildRowButtons = this.buildRowButtons.bind(this);
        this.getCardId = this.getCardId.bind(this);
    }

    componentDidMount() {
        const { id, immTransaction } = this.props;
        if (immTransaction.get('isExpanded')) {
            this.onRowClick(id);
            const element = document.getElementById(id);
            element && window.scrollTo(0, element.offsetTop + 250);
        }
    }

    componentWillReceiveProps(nextProps) {
        const { id, immTransaction, isExpanded } = nextProps;
        if (immTransaction.get('isExpanded') && !isExpanded && this.state.rowId !== id) {
            this.setState({
                rowId: id
            });
            this.onRowClick(id);
        }
    }

    componentDidUpdate(prevProps) {
        const { immTransaction, isExpanded } = prevProps;
        if (immTransaction.get('isExpanded') && isExpanded) {
            const element = document.getElementById(this.state.rowId);
            element && window.scrollTo(0, element.offsetTop + 250);
        }
    }

    onRowClick() {
        const { id, onRowClick } = this.props;
        onRowClick(id);
    }

    getCardId(pan) {
        const { immCards } = this.props;
        let hashedPan = '';
        immCards.get('byId').every((immCard) => {
            const fullPanNumber = immCard.getIn(['interventionList', 0, 'pan']);
            const last4DigitPanCard = fullPanNumber.substr(fullPanNumber.length - 4);
            const isPanNumberMatched = pan === last4DigitPanCard;
            if (isPanNumberMatched) {
                hashedPan = hash(fullPanNumber);
            }
            return !isPanNumberMatched;
        });
        return hashedPan;
    }

    goToSelectedPath(cardId, pathType, choreAssignmentId) {
        this.props.history.push(`/myprofile/cards/${cardId}/chores/${pathType}/${choreAssignmentId}`);
    }

    buildRowButtons() {
        const { immTransaction } = this.props;
        const choreAssignmentId = this.props.immTransaction.get('choreAssignmentId');
        const cardId = this.getCardId(immTransaction.get('last4DigitPan'));
        const paymentPath = 'payment-chore';
        const rejectPath = 'reject-chore';
        if (immTransaction.getIn(['choreStatus', 'choreStatusId']) === OPENYOUNG_CHORE_PENDING) {
            return (
                <div className="chore-list-table-row__buttons">
                    <span className="chore-list-table-row__buttons--pay-button">
                        <OKButton
                            modifier="secondary"
                            size="small"
                            onClick={() => this.goToSelectedPath(cardId, paymentPath, choreAssignmentId)}
                        >
                            <FormattedText value="openYoungChoresList-paymentButton" format="firstUppercase" />
                        </OKButton>
                    </span>
                    <span className="chore-list-table-row__buttons--reject-button">
                        <OKButton
                            modifier="ghost"
                            size="small"
                            onClick={() => this.goToSelectedPath(cardId, rejectPath, choreAssignmentId)}
                        >
                            <FormattedText value="openYoungChoresList-rejectButton" format="firstUppercase" />
                        </OKButton>
                    </span>
                </div>
            );
        }
    }

    render() {
        const {
            id,
            immTransaction,
            isExpanded
        } = this.props;

        const language = getLanguage();
        const currency = formatCurrency(EURO_TEXT);
        const reward = getFormattedString({ amount: immTransaction.get('reward'), currency });
        const toggleClass = classNames('chore-list-table-row__toggle--collapse', {
            'chore-list-table-row__toggle--expand': isExpanded
        });
        let tableRow = (<div></div>);
        const status = getFirstNWords(immTransaction.getIn(['choreStatus', 'choreStatus']), 1, '', 0).toLowerCase();
        if (immTransaction && immTransaction.getIn(['choreStatus', 'choreStatusId']) !== OPENYOUNG_CHORE_DELETED) {
            tableRow = (
                <OKTableRow id={id} isExpanded={isExpanded}>
                    <OKTableCell>
                        <OKCollapsingToggler className={toggleClass} handlerToggle={this.onRowClick} isExpanded={isExpanded} />
                    </OKTableCell>
                    <OKTableCell>
                        <LabelDate
                            date={immTransaction.get('createdDate')}
                            language={language}
                            today={LABEL_DATE_TODAY}
                            yesterday={LABEL_DATE_YESTERDAY}
                        />
                    </OKTableCell>
                    <OKTableCell className="chore-list-table-row__chore-description">
                        <span>{formatText(`openYoungCardChores-task${immTransaction.getIn(['chore', 'choreId'])}`)}</span>
                    </OKTableCell>
                    <OKTableCell>
                        <i className={`icon chore-list-table-row__icon-check chore-list-table-row__icon-check--${status}`} />
                        <span className="chore-list-table-row__status">
                            {formatText(`openYoungCardChores-status${immTransaction.getIn(['choreStatus', 'choreStatusId'])}`)}
                        </span>
                    </OKTableCell>
                    <OKTableCell className="chore-list-table-row__reward">
                        {reward}
                    </OKTableCell>
                    <OKTableCell>
                        {this.buildRowButtons()}
                    </OKTableCell>
                </OKTableRow>
            );
        }
        return tableRow;
    }
}

ChoreListTableRow.propTypes = {
    chore: PropTypes.object,
    history: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    immCards: PropTypes.object.isRequired,
    immTransaction: PropTypes.object.isRequired,
    isExpanded: PropTypes.bool,
    onRowClick: PropTypes.func,
};

module.exports.ChoreListTableRow = connect(
    state => ({
        immCards: state.cards,
    }))(withRouter(ChoreListTableRow));
